exports = module.exports = require("../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comparison-table__score-icon-wrapper{height:19px;width:27px}.comparison-table__score-icon{height:100%}.comparison-table__aside{position:relative}.comparison-table__aside .MapApp{height:229px}.comparison-table .opener-box{position:absolute;width:100%}.facility-row-item{display:flex!important;align-items:center!important;gap:7px!important}.facility-row-item__text{font-weight:600;line-height:100%}", ""]);

// exports
